export enum ApiOrdersField {
  OpeningStaffName = 'opening_staff_name',
  ClosingStaffName = 'closing_staff_name',
  OrderClosedAt = 'order_closed_at',
  OrderCreatedAt = 'order_created_at',
  OrderCustomersCount = 'order_customers_count',
  OrderDiscountAmount = 'order_discount_amount',
  OrderName = 'order_name',
  OrderOpenedAt = 'order_opened_at',
  OrderStatus = 'order_status',
  OrderTotalCancelled = 'order_total_cancelled',
  OrderTotalDiscount = 'order_total_discount',
  OrderTotalTaxAmount = 'order_total_tax_amount',
  OrderTotalTaxExcluded = 'order_total_tax_excluded',
  OrderTotalTaxIncluded = 'order_total_tax_included',
  OrderUuid = 'order_uuid',
  PaymentStatus = 'payment_status',
  StoreId = 'store_id',
  SumPayments = 'sum_payments',
  TableName = 'table_name',
}

export enum ApiAggregatedOrdersField {
  SumOrderCustomersCount = 'sum_order_customers_count',
  SumOrderTotalTaxIncluded = 'sum_order_total_tax_included',
  SumOrderTotalTaxExcluded = 'sum_order_total_tax_excluded',
  SumOrderTotalTaxAmount = 'sum_order_total_tax_amount',
  SumOrderTotalCancelled = 'sum_order_total_cancelled',
  SumOrderDiscountAmount = 'sum_order_discount_amount',
  SumOrderTotalDiscount = 'sum_order_total_discount',
  OrderStatus = 'order_status',
  Hour = 'hour',
  Day = 'day',
  Week = 'week',
  SevenDays = 'sevendays',
  Month = 'month',
  Year = 'year',
}

export enum ApiOrdersAggregate {
  Status = 'status',
  Hour = 'hour',
  Day = 'day',
  Week = 'week',
  SevenDays = 'sevenDays',
  Month = 'month',
  Year = 'year',
}
